import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isAddScholarship: false,
};

const scholarshipFunctionalSlice = createSlice({
  name: "scholarshipFunctional",
  initialState,
  reducers: {
    setIsAddScholarship: (state, action: PayloadAction<boolean>) => {
      state.isAddScholarship = action.payload;
    },
  },
});

export const { setIsAddScholarship } = scholarshipFunctionalSlice.actions;
export default scholarshipFunctionalSlice.reducer;
